import { FormEvent, useMemo, useState } from "react";
import { localAuthDefaultUserId } from "./localAuthConfig";
import { storeLocalDaytimePreview } from "../app/LocalDaytimePreview";
import { useSomaAuth } from "./SomaAuthContext";
import styles from "./LocalAuthLogin.module.css";

const LocalAuthLogin = () => {
  const { localUsers, signInToLocalAuth } = useSomaAuth();
  const [daytimePreview, setDaytimePreview] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(() =>
    localUsers.some((user) => user.id === localAuthDefaultUserId)
      ? localAuthDefaultUserId
      : (localUsers[0]?.id ?? "")
  );

  const selectedUser = useMemo(
    () => localUsers.find((user) => user.id === selectedUserId) ?? null,
    [localUsers, selectedUserId]
  );

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!selectedUserId) {
      return;
    }

    storeLocalDaytimePreview(daytimePreview);
    signInToLocalAuth(selectedUserId);
  };

  return (
    <div className={styles.shell}>
      <div className={styles.panel}>
        <div className={styles.eyebrow}>Aspire Local Login</div>
        <h1 className={styles.title}>Sign in to SOMA</h1>
        <p className={styles.subtitle}>
          This local login is served entirely from the repo and uses the real SOMA backend through
          Aspire.
        </p>

        <form className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.label} htmlFor="local-auth-user">
            Local user
          </label>
          <select
            id="local-auth-user"
            className={styles.select}
            value={selectedUserId}
            onChange={(event) => setSelectedUserId(event.target.value)}
          >
            {localUsers.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>

          {selectedUser && (
            <div className={styles.card}>
              <div className={styles.cardTitle}>{selectedUser.name}</div>
              <div>{selectedUser.email}</div>
              <div className={styles.cardMeta}>User id: {selectedUser.id}</div>
            </div>
          )}

          {import.meta.env.DEV && (
            <label className={styles.preview}>
              <input
                type="checkbox"
                checked={daytimePreview}
                onChange={(event) => setDaytimePreview(event.target.checked)}
              />
              Daytime production preview (simulation)
            </label>
          )}
          <button type="submit" className={styles.button} disabled={!selectedUserId}>
            Continue to SOMA
          </button>
        </form>
      </div>
    </div>
  );
};

export default LocalAuthLogin;
